import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import global from './global/GlobalReducer'
import composer from './composer/ComposerReducer'

const rootReducer = combineReducers({
  global,
  composer,
})

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore)
const configureStore = (initialState) => createStoreWithMiddleware(rootReducer, initialState)
export default configureStore


// WEBPACK FOOTER //
// ./src/state/createStore.js